import React from "react";
import connectToStores from "alt-utils/lib/connectToStores";
import BackButton from "./partials/back-button.jsx";

import UserStore from "../stores/UserStore.js";
import config from "../config.js";

class MailingPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previewHtml: "",
      loading: true
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      "preview-frame": {
        height: "500px",
        width: "100%"
      }
    };
  }

  componentDidMount() {
    this.fetchEmailPreview();
  }

  fetchEmailPreview = async () => {
    try {
      const response = await fetch(
        `${config.endpoint}mailings/${
          this.props.params.mailingId
        }/preview?${UserStore.makeApiKeyQueryString()}`
      );

      const html = await response.json();
      this.setState({ loading: false, previewHtml: html });
    } catch (err) {
      alert(`Error fetching preview data: ${err}`);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const styles = this.getStyles();

    return (
      <div>
        <BackButton
          label="Back"
          location={`/event_buckets/${this.props.params.eventBucketId}/mailings/${this.props.params.mailingId}`}
          style={{ marginBottom: 10 }}
        />
        {this.state.loading ? (
          <div>loading...</div>
        ) : (
          <iframe
            style={styles["preview-frame"]}
            srcDoc={this.state.previewHtml}
            sandbox
          />
        )}
      </div>
    );
  }
}

export default MailingPreview;



// WEBPACK FOOTER //
// ./src/app/components/mailing-preview.jsx